import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import { Card, CardBody,CardImg, Button, CardTitle, CardText, Input, Modal, ModalBody, ModalHeader} from "reactstrap";
import Loading from '../../../../../hoc/Loading/Loading';
import axios from '../../../../../axios';
import * as actionCreators from '../../../../../modules/actions/index';
import * as url from '../../../../../utils/url';
import { dashboardChartSize, uploadPreview,checkUploadType} from '../../../../../utils/constants';
import moment from 'moment';



 class DashboardNotesItem extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      notes:[],
      isUploadFiles:false,
      isSubmit:false,
      setImagesPreview:[],
      rejectedFiles:[],
      dashboard: this.props.reports
      // attachments: this.props.task_copy.attachments
     }
  }

getUpload = ()=>{
    this.setState({isUploadFiles:true})
}

  componentDidUpdate(prevProps) {
    // console.log('curent: ', prevProps.reports)
    // console.log('this.props: ', this.props.reports)
    
    let notes = prevProps.reports.notes && prevProps.reports.notes.length>0?prevProps.reports.notes:[]
    let newNotes = this.props.reports.notes && this.props.reports.notes.length>0?this.props.reports.notes:[]

    if(notes != newNotes){
      if(newNotes.length>notes.length){
        this.setState({
          attachments:this.props.reports.notes
        })
      }
    }

     

    let curr_up = this.props.reports.isUploadFiles
    let prev_up = prevProps.reports.isUploadFiles

    // console.log(prev_up, '--------', curr_up)
    if(curr_up!=prev_up && (curr_up!=null)){
      this.setState({isUploadFiles: curr_up})
    }
  }


uploadAttachments=()=>{
  let{setImagesPreview }=this.state
  let{reports}=this.props
  const formData = new FormData();
  this.setState({isSubmit:true})
  if(setImagesPreview && setImagesPreview.length>0){
  console.log('setImagesPreview: ', setImagesPreview)

  Array.from(setImagesPreview).forEach(itm => {
    delete itm.isAccepted 
    formData.append('uploads', itm.file);
  })
  

  formData.append('_id', reports._id)
  // formData.append('isAttachments', task_copy.attachItems)

  let that=this

  console.log('upload files---')

  axios.post(url.dashboardUploadFiles, formData, { headers: {
    'Content-Type': 'multipart/form-data'
  }}).then(({ data }) => {
    // console.log('data---', data.data)
    let result = data.data
    delete result.createdBy


    let new_item={...reports,...result, isUploadFiles:false }
    that.props.updateReport(new_item)
    that.setState({
      // isActionsModal:false,
      // isResourceSelect:null,
      // isUploadFiles:false,
      rejectedFiles:[],
      isSubmit:false,
      setImagesPreview:[]
     }) 
  })
}else {
  this.setState({
    uploadFileErr:'No files to Upload'
  })
}

 
}

fileSelectedHandler = (e) => {

  if(e.target.files){
    let arr=[]
    let fileArr = Array.from(e.target.files).map((file, idx)=> {
      // console.log('file: ', file)
      let obj= {
        name: file.name,
        type: file.type,
        size: file.size,
        file,
        datetime: Date.now().toString(),
        // blob: URL.createObjectURL(file),
        preview: URL.createObjectURL(file),
        isAccepted:checkUploadType(file.type)
      }
      return uploadPreview(obj)
    })
    
    let acceptedFiles = fileArr.filter(e=>e.isAccepted==true).map(e=>{ 
      delete e.isAccepted 
      return e
    })
    let rejectedFiles = fileArr.filter(e=>e.isAccepted==false)
    let allUploads = acceptedFiles.concat(rejectedFiles) 
    this.setState((prevState)=> ({
      setImagesPreview: prevState.setImagesPreview.concat(acceptedFiles),
      rejectedFiles:prevState.rejectedFiles.concat(rejectedFiles),
    }))
    Array.from(e.target.files).map(file=> URL.revokeObjectURL(file))
  }
}

  removeImage=(photo)=>{
    let{setImagesPreview}=this.state
    let{preview}=photo
    setImagesPreview.map(el=> URL.revokeObjectURL(el.file))
    let result = setImagesPreview.filter(e=>e.preview!=preview)
    URL.revokeObjectURL(preview)
    URL.revokeObjectURL(photo.file)
    this.setState({setImagesPreview:result})
  }


  renderUploadPreview = source => {
    let{rejectedFiles}=this.state
 
    
    return source.map((photo,idx) =>{
      let{preview, size}=photo
      let mb = 1024*1024
      let file_size = size>= mb? `${(size/mb).toFixed(2)}mb`:`${(size/1024).toFixed(2)}kb`   
      return (<span key={idx} className={photo.isAccepted==false? "taskUploadPreviewImg rejectedFilesContainer":'taskUploadPreviewImg'}>
         <img src={preview}  className="fileUploadSize"/>
        {/* {photo.isMsIcon?
        <div classaName="imageUploadBlobSrc">
            <iframe src={preview} class="imgBlobSrc" scrolling="no" scroll="no" />
        </div>
        :
        <img src={preview}  className="fileUploadSize"/>
        } */}
        
          <span key={preview+idx} onClick={()=>this.removeImage(photo, )} className="removeTaskUpload"><span className='flaticon-trash'/></span>
          <div className="previewTaskImageText">
            <span className="previewTaskImageTitle">
              {photo.name}
            </span>
            <span className="previewTaskImageTitle">
              {file_size}
            </span>
            {/* {photo.isAccepted==false?
            <span className="previewUploadFileError">
              The following file will not be uploaded because of its file type
            </span>
            :null} */}
          </div>
        </span>)
    })
  }



  handleClick = event => {
    const { target = {} } = event || {};
    target.value = "";
  };

  closeActionsModal=()=>{
    this.setState({setImagesPreview:[], rejectedFiles:[]})
    this.props.updateReport({isUploadFiles:false})
  }


  render() { 
    let{setImagesPreview, isUploadFiles, rejectedFiles,isSubmit}=this.state
      return (<span>
               <Modal isOpen={isUploadFiles} className="uploadFilesModalContainer dashboardModalUpload">
               <ModalHeader className="dashboardHeader" charCode="X"
                  toggle={this.closeActionsModal} >
                  <div className="dashboardModalTitle"> Upload Files</div>
                </ModalHeader>
                      
                      <ModalBody className="taskUploadFileModal">
                    
                        <div className="singleTaskModalBody mb0">   
                        
                        {rejectedFiles && rejectedFiles.length>0?
                        <div className="rejectedFilesContainer">
                          <span className="">
                            The following file(s) will not be uploaded because of the file type: 
                          </span>
                           &nbsp;
                          {rejectedFiles.map( (e, idx)=>{
                            let name= idx==rejectedFiles.length-1? e.name+'.': e.name+', '
                            return name
                          })}
                        </div>
                        : null}  

                        <div >
                          {setImagesPreview && setImagesPreview.length>0?
                          <div className="taskUploadPreviewContainer mb0">
                            { this.renderUploadPreview(setImagesPreview) }
                          </div>
                          :
                          null
                          }
                        </div>

                        </div>

                        <div className="singleTaskUploadModalBtn">

                    <label htmlFor="profile-pic-file-input" style={{marginBottom: '0px'}}>
                                      <span className={`actionsByStatus singleTaskUpload ${isSubmit?'opacity40':''}`} >
                                      <span className="flaticon-upload"/>Choose Files</span>
                                      </label>
                                      <input id="profile-pic-file-input" onClick={!isSubmit? this.handleClick:null} 
                                      onChange={this.fileSelectedHandler} type="file" multiple
                                      />
                        </div>

                        
                            <Button className={setImagesPreview&&setImagesPreview.length>0 && !isSubmit?"uploadFilesBtn":'opacity40 uploadFilesBtn'}
                              onClick={setImagesPreview && setImagesPreview.length>0 && !isSubmit? ()=>this.uploadAttachments():null} 
                              >
                              <span className="">
                                Upload
                                <span className="ml10 flaticon-tick"></span></span>
                            </Button>
                            <Button className={`cancelFilesBtn ${isSubmit?'opacity40':''}`} onClick={!isSubmit? ()=>this.closeActionsModal():null}>
                              <span className="profile-modal-cancel-btn-txt">Cancel</span>
                            </Button>
                      </ModalBody>
                  </Modal>
              </span>
      )   
  }
}




const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) => dispatch(actionCreators.updateReport(dashboard))

  }
}
 
// export default LinkedCharts;
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(DashboardNotesItem, axios)));
